import { useEffect, useState } from "react";
import MissingSkincareComponent from "../../components/missingSkincare";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { getMissingSkincareApi } from "../../services/skincare.service";
import PageLoader from "../../components/common/loader/pageLoader";

interface MissingSkincareContainerInterface { }

const MissingSkincare: React.FC<MissingSkincareContainerInterface> = () => {
    const profile = useAppSelector((state) => state.profile);
    const dispatch = useAppDispatch();
    const [data, setData] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);

    const fetchMissingSkincareData = () => {
        dispatch(getMissingSkincareApi({
            finalCallback: () => {
                setLoading(false);
            },
            successCallback: (data?: any) => {
                setData(data);
            }
        }))
    };

    useEffect(() => {
        setLoading(true);
        fetchMissingSkincareData();
    }, []);

    if (loading) {
        return <PageLoader />;
    }

    return (
        <MissingSkincareComponent data={data} profile={profile} />
    )
}

export default MissingSkincare